import { chain, isEmpty } from "lodash"
import { CONTENT_SET_DATA_TYPES } from "./contentSetConstants"

export function getOptimizationContentSetsQueryNodes(contentSets) {
  if (isEmpty(contentSets)) {
    return ""
  }

  return chain(contentSets)
    .map(({ id, escapedId, dataType }) => {
      const field = dataType === CONTENT_SET_DATA_TYPES.SENSITIVITY ? "currencyExposure" : "net"
      return `${escapedId}: exposure (contentSetId: "${id}") { factors { id, value: ${field}, name, category } } `
    })
    .join("\n")
    .value()
}

export function escapeContentSetId(id) {
  return chain(id)
    .replace(/-/g, "_")
    .replace(/(^[0-9])/, "CS_$1")
    .value()
}
